import React from "react";

const InstructionsSection = () => {
  return (
    <div className="container">
      <p className="lead mb-5">
        Puedes elegir hasta <strong>3 videos</strong> que consideres son los
        mejores. Te pediremos tu correo electrónico al que enviaremos un enlace
        de confirmación para <strong>validar</strong> tus votos. Preferentemente utiliza una dirección de correo de <strong>GMAIL</strong>. 
        La solicitud de su correo electrónico es para respaldar la transparencia de la votación
        y hacer la validación minuciosa de todos los votos.
      </p>
    </div>
  );
};

export default InstructionsSection;
